import Vue from "vue";
import Vuex from "vuex";
import * as BRANCHES from "./module/BranchStore";
import * as comanStore from "./module/comanStore";
import * as Users from "./module/auth";
import * as cashStore from "./module/cashStore";
import * as products from "./module/productStore";
import * as links from "./module/links";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    BRANCHES,
    comanStore,
    Users,
    cashStore,
    products,
    links,
  },
});
